import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../interfaces/base";
import { IFetchWorkoutsAction } from "../../../interfaces/store/workouts-interface";
import {
  fetchWorkoutsSuccess,
  fetchWorkoutsFailed,
  fetchWorkoutsStart,
} from "./workouts-slice";
import { searchWorkoutsApi } from "../../../api/workouts";

function* _fetchWorkouts({ payload }: IFetchWorkoutsAction) {
  try {
    const { sort, filter, pagination, search } = payload;

    const response: IBaseResponse = yield call(searchWorkoutsApi, {
      sort: sort || { sortBy: "updatedAt", sortOrder: -1 },
      search,
      filter,
      pagination,
    });

    if (response.error) {
      yield put(fetchWorkoutsFailed(response.error));
    } else {
      yield put(fetchWorkoutsSuccess({ data: response.data }));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchWorkoutsFailed({ message: error.message }));
  }
}

function* workoutsSaga() {
  yield takeLatest(fetchWorkoutsStart.type, _fetchWorkouts);
}

export default workoutsSaga;
